import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import { InventaireForm } from '@features/stock/components/InventaireForm'
import { useInventaire } from '@features/stock/hooks/useInventaires'
import { useUpdateInventaire } from '@features/stock/hooks/useInventaireMutations'

export const Route = createFileRoute('/_app/stock/inventaires/$id/edit')({
  loader: requirePermission('stock.inventaires.edit'),
  component: EditInventaire,
})

function EditInventaire() {
  const { id } = Route.useParams()
  const navigate = useNavigate()
  const { data: inventaire, isLoading } = useInventaire(Number(id))
  const updateMutation = useUpdateInventaire()

  const handleSuccess = () => {
    navigate({ to: '/stock/inventaires' })
  }

  if (isLoading) {
    return <div className="skeleton h-32 w-full" />
  }

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Modifier l'inventaire</h1>
      <div className="bg-base-100 rounded-lg shadow p-6">
        <InventaireForm
          mode="edit"
          initialData={inventaire}
          onSuccess={handleSuccess}
        />
      </div>
    </div>
  )
}
